export default "__VITE_ASSET__4zuxJ5jA__"